// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sidebar-width: 220px;
}

.SideNavMenu-module_nav_popover_aV3WV {
  display: initial !important;
}

.SideNavMenu-module_nav_box_r76GY {
  height: calc(100vh);
  position: sticky;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  max-width: var(--sidebar-width);
  min-width: calc(var(--sidebar-width) - 1px);
  transition: all 0.3s ease-in-out;
  border-right-color: var(--bp-light-gray1);
  border-right-width: thin;
  border-right-style: solid;
  background: var(--side-nav-bg-color);
  overflow-x: clip;
}

.SideNavMenu-module_nav_box_minified_Latgs {
  position: absolute;
  bottom: 0;
  z-index: 12;
  transition: all 0.3s ease-in-out;
}

.SideNavMenu-module_nav_box_minified_opened_kbnBI {
  box-shadow: rgba(84, 117, 145, 0.1) 0px 0px 6px 6px;
}

.SideNavMenu-module_nav_box_minified_closed__a4Hz {
  max-width: 57px;
  min-width: 57px;
}

.SideNavMenu-module_nav_box_dummy_YfrqV {
  flex-shrink: 0;
  width: 57px;
}

.SideNavMenu-module_menu_text_pbSVO {
  margin-left: 10px;
  margin-right: 10px;
  transition: max-width 0.25s cubic-bezier(0.4, 1, 0.75, 0.9);
}

.SideNavMenu-module_menu_text_hidden_twynZ {
  display: none;
}

.SideNavMenu-module_tab_box_weoW6 {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  overflow-x: clip;
}

.SideNavMenu-module_tab_box_weoW6 a {
  text-decoration: none !important;
}

.SideNavMenu-module_tab_box_weoW6 a span {
  color: var(--uu-text);
  font-weight: 600;
}

.SideNavMenu-module_tab_box_weoW6 a .SideNavMenu-module_menu_text_sub_menu_Xy05y {
  margin-left: 8px;
  margin-right: 8px;
  color: var(--uu-text-lighter);
  font-weight: 400;
  font-size: 11pt;
}

.SideNavMenu-module_tab_box_weoW6 a:hover span {
  color: var(--primary-hover-color);
}

.SideNavMenu-module_tab_common_UASEK {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  margin-top: 0;
  white-space: nowrap;
  position: relative;
  cursor: pointer;
  border-left: 7px solid transparent;
  box-sizing: border-box;
}

.SideNavMenu-module_tab_common_UASEK span {
  transition: color 0.5s ease;
}

.SideNavMenu-module_tab_left_justify_AbmAF {
  padding-left: 10px;
  padding-right: 10px;
  justify-content: start;
}

.SideNavMenu-module_tab_center_justify_I15vi {
  justify-content: center;
  margin-right: 7px;
}

.SideNavMenu-module_active_tab_ybuGS {
  border-color: var(--uu-utah-red);
}

.SideNavMenu-module_active_tab_expanded_HCEHL {
  margin-right: 2px;
}

.SideNavMenu-module_active_tab_ybuGS span {
  /* color: white !important; */
}

.SideNavMenu-module_active_sub_tab_kYEXs {
}

.SideNavMenu-module_active_sub_tab_expanded_h8Coa {
}

.SideNavMenu-module_tall_tab_common_vxVA2 {
  font-size: 12pt;
  height: 52px;
  margin-top: 2px;
  margin-bottom: 2px;
}

.SideNavMenu-module_tall_tab_ITBz2 {
}

.SideNavMenu-module_tall_tab_centered_LkRy7 {
}

.SideNavMenu-module_sub_tab_PH3ix {
  height: 40px;
  padding-left: 30px;
  padding-right: 30px;
}

.SideNavMenu-module_sub_tab_PH3ix:first-child {
}

.SideNavMenu-module_sub_tab_minified_UXoai {
}

.SideNavMenu-module_sub_tab_group_QZWDv {
  margin-top: -8px;
  overflow: hidden;
  height: auto;
  transition: margin-top linear 0.1s, height ease-in-out 0.5s 0.1s;
}

.SideNavMenu-module_sub_tab_group_hidden_x_nJu {
  margin-top: 0;
  transition: height ease-out 0.5s, margin-top linear 0.1s 0.5s;
}

.SideNavMenu-module_lower_menu_box_ZUp7v {
  margin-top: auto;
}

.SideNavMenu-module_home_button_box_pB9j_ {
  width: 100%;
  border-bottom-color: var(--bp-light-gray1);
  border-bottom-width: thin;
  border-bottom-style: solid;
}

.SideNavMenu-module_drawer_button_box_H9jF_ {
  width: 100%;
  border-top-color: var(--bp-light-gray1);
  border-top-width: thin;
  border-top-style: solid;
}

.SideNavMenu-module_drawer_button_allwN {
  color: var(--bp-dark-gray5);
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
}

.SideNavMenu-module_drawer_button_allwN:hover {
  cursor: pointer;
  color: var(--primary-hover-color);
}

.SideNavMenu-module_drawer_button_centered_tU2BR {
  margin-right: unset;
  justify-content: center;
}

.SideNavMenu-module_drawer_button_right_EuSR8 {
  margin-right: 10px;
  flex-direction: row-reverse;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/Navigation/SideNavMenu.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,2CAA2C;EAC3C,gCAAgC;EAChC,yCAAyC;EACzC,wBAAwB;EACxB,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EAEE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gCAAgC;AAClC;;AAEA;EAEE,mDAAmD;AACrD;;AAEA;EAEE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EAGE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;AAGA;;AAEA;AAGA;;AAEA;EAGE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;AACA;;AAEA;AAGA;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gEAAgE;AAClE;;AAEA;EAEE,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EAEE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EAEE,kBAAkB;EAClB,2BAA2B;AAC7B","sourcesContent":[":root {\n  --sidebar-width: 220px;\n}\n\n.nav_popover {\n  display: initial !important;\n}\n\n.nav_box {\n  height: calc(100vh);\n  position: sticky;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  max-width: var(--sidebar-width);\n  min-width: calc(var(--sidebar-width) - 1px);\n  transition: all 0.3s ease-in-out;\n  border-right-color: var(--bp-light-gray1);\n  border-right-width: thin;\n  border-right-style: solid;\n  background: var(--side-nav-bg-color);\n  overflow-x: clip;\n}\n\n.nav_box_minified {\n  composes: nav_box;\n  position: absolute;\n  bottom: 0;\n  z-index: 12;\n  transition: all 0.3s ease-in-out;\n}\n\n.nav_box_minified_opened {\n  composes: nav_box_minified;\n  box-shadow: rgba(84, 117, 145, 0.1) 0px 0px 6px 6px;\n}\n\n.nav_box_minified_closed {\n  composes: nav_box_minified;\n  max-width: 57px;\n  min-width: 57px;\n}\n\n.nav_box_dummy {\n  flex-shrink: 0;\n  width: 57px;\n}\n\n.menu_text {\n  margin-left: 10px;\n  margin-right: 10px;\n  transition: max-width 0.25s cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n\n.menu_text_hidden {\n  composes: menu_text;\n  display: none;\n}\n\n.tab_box {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: clip;\n}\n\n.tab_box a {\n  text-decoration: none !important;\n}\n\n.tab_box a span {\n  color: var(--uu-text);\n  font-weight: 600;\n}\n\n.tab_box a .menu_text_sub_menu {\n  margin-left: 8px;\n  margin-right: 8px;\n  color: var(--uu-text-lighter);\n  font-weight: 400;\n  font-size: 11pt;\n}\n\n.tab_box a:hover span {\n  color: var(--primary-hover-color);\n}\n\n.tab_common {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0;\n  margin-top: 0;\n  white-space: nowrap;\n  position: relative;\n  cursor: pointer;\n  border-left: 7px solid transparent;\n  box-sizing: border-box;\n}\n\n.tab_common span {\n  transition: color 0.5s ease;\n}\n\n.tab_left_justify {\n  padding-left: 10px;\n  padding-right: 10px;\n  justify-content: start;\n}\n\n.tab_center_justify {\n  justify-content: center;\n  margin-right: 7px;\n}\n\n.active_tab {\n  composes: tab_common;\n  border-color: var(--uu-utah-red);\n}\n\n.active_tab_expanded {\n  composes: active_tab;\n  composes: tab_left_justify;\n  margin-right: 2px;\n}\n\n.active_tab span {\n  /* color: white !important; */\n}\n\n.active_sub_tab {\n  composes: active_tab;\n}\n\n.active_sub_tab_expanded {\n  composes: active_tab_expanded;\n}\n\n.tall_tab_common {\n  composes: tab_common;\n  font-size: 12pt;\n  height: 52px;\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n\n.tall_tab {\n  composes: tall_tab_common;\n  composes: tab_left_justify;\n}\n\n.tall_tab_centered {\n  composes: tall_tab_common;\n  composes: tab_center_justify;\n}\n\n.sub_tab {\n  composes: tab_common;\n  composes: tab_left_justify;\n  height: 40px;\n  padding-left: 30px;\n  padding-right: 30px;\n}\n\n.sub_tab:first-child {\n}\n\n.sub_tab_minified {\n  composes: sub_tab;\n  composes: tab_center_justify;\n}\n\n.sub_tab_group {\n  margin-top: -8px;\n  overflow: hidden;\n  height: auto;\n  transition: margin-top linear 0.1s, height ease-in-out 0.5s 0.1s;\n}\n\n.sub_tab_group_hidden {\n  composes: sub_tab_group;\n  margin-top: 0;\n  transition: height ease-out 0.5s, margin-top linear 0.1s 0.5s;\n}\n\n.lower_menu_box {\n  margin-top: auto;\n}\n\n.home_button_box {\n  width: 100%;\n  border-bottom-color: var(--bp-light-gray1);\n  border-bottom-width: thin;\n  border-bottom-style: solid;\n}\n\n.drawer_button_box {\n  width: 100%;\n  border-top-color: var(--bp-light-gray1);\n  border-top-width: thin;\n  border-top-style: solid;\n}\n\n.drawer_button {\n  color: var(--bp-dark-gray5);\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n}\n\n.drawer_button:hover {\n  cursor: pointer;\n  color: var(--primary-hover-color);\n}\n\n.drawer_button_centered {\n  composes: drawer_button;\n  margin-right: unset;\n  justify-content: center;\n}\n\n.drawer_button_right {\n  composes: drawer_button;\n  margin-right: 10px;\n  flex-direction: row-reverse;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav_popover": `SideNavMenu-module_nav_popover_aV3WV`,
	"nav_box": `SideNavMenu-module_nav_box_r76GY`,
	"nav_box_minified": `SideNavMenu-module_nav_box_minified_Latgs SideNavMenu-module_nav_box_r76GY`,
	"nav_box_minified_opened": `SideNavMenu-module_nav_box_minified_opened_kbnBI SideNavMenu-module_nav_box_minified_Latgs SideNavMenu-module_nav_box_r76GY`,
	"nav_box_minified_closed": `SideNavMenu-module_nav_box_minified_closed__a4Hz SideNavMenu-module_nav_box_minified_Latgs SideNavMenu-module_nav_box_r76GY`,
	"nav_box_dummy": `SideNavMenu-module_nav_box_dummy_YfrqV`,
	"menu_text": `SideNavMenu-module_menu_text_pbSVO`,
	"menu_text_hidden": `SideNavMenu-module_menu_text_hidden_twynZ SideNavMenu-module_menu_text_pbSVO`,
	"tab_box": `SideNavMenu-module_tab_box_weoW6`,
	"menu_text_sub_menu": `SideNavMenu-module_menu_text_sub_menu_Xy05y`,
	"tab_common": `SideNavMenu-module_tab_common_UASEK`,
	"tab_left_justify": `SideNavMenu-module_tab_left_justify_AbmAF`,
	"tab_center_justify": `SideNavMenu-module_tab_center_justify_I15vi`,
	"active_tab": `SideNavMenu-module_active_tab_ybuGS SideNavMenu-module_tab_common_UASEK`,
	"active_tab_expanded": `SideNavMenu-module_active_tab_expanded_HCEHL SideNavMenu-module_active_tab_ybuGS SideNavMenu-module_tab_common_UASEK SideNavMenu-module_tab_left_justify_AbmAF`,
	"active_sub_tab": `SideNavMenu-module_active_sub_tab_kYEXs SideNavMenu-module_active_tab_ybuGS SideNavMenu-module_tab_common_UASEK`,
	"active_sub_tab_expanded": `SideNavMenu-module_active_sub_tab_expanded_h8Coa SideNavMenu-module_active_tab_expanded_HCEHL SideNavMenu-module_active_tab_ybuGS SideNavMenu-module_tab_common_UASEK SideNavMenu-module_tab_left_justify_AbmAF`,
	"tall_tab_common": `SideNavMenu-module_tall_tab_common_vxVA2 SideNavMenu-module_tab_common_UASEK`,
	"tall_tab": `SideNavMenu-module_tall_tab_ITBz2 SideNavMenu-module_tall_tab_common_vxVA2 SideNavMenu-module_tab_common_UASEK SideNavMenu-module_tab_left_justify_AbmAF`,
	"tall_tab_centered": `SideNavMenu-module_tall_tab_centered_LkRy7 SideNavMenu-module_tall_tab_common_vxVA2 SideNavMenu-module_tab_common_UASEK SideNavMenu-module_tab_center_justify_I15vi`,
	"sub_tab": `SideNavMenu-module_sub_tab_PH3ix SideNavMenu-module_tab_common_UASEK SideNavMenu-module_tab_left_justify_AbmAF`,
	"sub_tab_minified": `SideNavMenu-module_sub_tab_minified_UXoai SideNavMenu-module_sub_tab_PH3ix SideNavMenu-module_tab_common_UASEK SideNavMenu-module_tab_left_justify_AbmAF SideNavMenu-module_tab_center_justify_I15vi`,
	"sub_tab_group": `SideNavMenu-module_sub_tab_group_QZWDv`,
	"sub_tab_group_hidden": `SideNavMenu-module_sub_tab_group_hidden_x_nJu SideNavMenu-module_sub_tab_group_QZWDv`,
	"lower_menu_box": `SideNavMenu-module_lower_menu_box_ZUp7v`,
	"home_button_box": `SideNavMenu-module_home_button_box_pB9j_`,
	"drawer_button_box": `SideNavMenu-module_drawer_button_box_H9jF_`,
	"drawer_button": `SideNavMenu-module_drawer_button_allwN`,
	"drawer_button_centered": `SideNavMenu-module_drawer_button_centered_tU2BR SideNavMenu-module_drawer_button_allwN`,
	"drawer_button_right": `SideNavMenu-module_drawer_button_right_EuSR8 SideNavMenu-module_drawer_button_allwN`
};
export default ___CSS_LOADER_EXPORT___;
